import React, { useState, useEffect } from "react";
import BaskentLogo from "assets/images/baskent-logo.svg";
import ToroslarLogo from "assets/images/toroslar-logo.svg";
import AyedasLogo from "assets/images/ayedas-logo.svg";
import Input from "components/UI/Input";
import Button from "components/UI/Button";
import Checkbox from "components/UI/Checkbox";
import styles from "./style.module.scss";
import SelectComponent from "components/UI/Select";
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'
import Validator from "libs/validator";
import LoaderSpinner from "components/UI/LoaderSpinner/LoaderSpinner";
import { locationController } from "utils/locationhelper";


const data2 = [
  {
    label: "Müşteri",
    value: "1",
  },
  {
    label: "Tedarikçi",
    value: "2",
  },
];



const RegisterPage = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [checked, setChecked] = useState(false);
  const [arrow2, setArrow2] = useState(false);
  const [role, setRole] = useState("Seçiniz");
  const [uploadedFiles1, setUploadedFiles1] = useState<any[]>([]);
  const [uploadedFiles2, setUploadedFiles2] = useState<any[]>([]);
  const [uploadedFiles3, setUploadedFiles3] = useState<any[]>([]);
  const [uploadedFiles4, setUploadedFiles4] = useState<any[]>([]);
  const [uploadedFiles5, setUploadedFiles5] = useState<any[]>([]);


  const oneFileMessage = "Yalnızca 1 dosya seçebilirsiniz";
  const sizeLimitMessage = "Lütfen 2 MB'tan küçük dosya yükleyiniz";
  const uploadLimit = 2 * 1048576;

  const [isLoading, setIsLoading] = useState(false);

  const getPostData = async () => {
    var formdata = new FormData();
    formdata.append("PhoneNumber", String(phone));
    formdata.append("Name", String(name));
    formdata.append("Surname", String(surname));
    formdata.append("RoleId", String(role));
    formdata.append("Eposta", String(email));

    let companyId = locationController();

    formdata.append("CompanyId", String(companyId));

    for (let i = 0; i < uploadedFiles1.length; i++) {
      formdata.append(`Doc1.File`, uploadedFiles1[i]);
      formdata.append(`Doc1.Name`, uploadedFiles1[i].name);
      formdata.append(`Doc1.DocumentType`, "Evrak1");
    }

    for (let i = 0; i < uploadedFiles2.length; i++) {
      formdata.append(`Doc2.File`, uploadedFiles2[i]);
      formdata.append(`Doc2.Name`, uploadedFiles2[i].name);
      formdata.append(`Doc2.DocumentType`, "Evrak2");
    }

    for (let i = 0; i < uploadedFiles3.length; i++) {
      formdata.append(`Doc3.File`, uploadedFiles3[i]);
      formdata.append(`Doc3.Name`, uploadedFiles3[i].name);
      formdata.append(`Doc3.DocumentType`, "Evrak3");
    }


    for (let i = 0; i < uploadedFiles4.length; i++) {
      formdata.append(`Doc4.File`, uploadedFiles4[i]);
      formdata.append(`Doc4.Name`, uploadedFiles4[i].name);
      formdata.append(`Doc4.DocumentType`, "Evrak4");
    }


    for (let i = 0; i < uploadedFiles5.length; i++) {
      formdata.append(`Doc5.File`, uploadedFiles5[i]);
      formdata.append(`Doc5.Name`, uploadedFiles5[i].name);
      formdata.append(`Doc5.DocumentType`, "Evrak5");
    }




    return formdata;
  }

  const handleFileDeleteEvent = (number: number) => {
    
    if(number === 1){
      setUploadedFiles1([]);
    }
    if(number === 2){
      setUploadedFiles2([]);
    }
    
    if(number === 3){
      setUploadedFiles3([]);
    }
    
    if(number === 4){
      setUploadedFiles4([]);
    }
    
    if(number === 5){
      setUploadedFiles5([]);
    }
    
  };
  

  const handleFileEvent = (e: any, number: number) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);

    handleUploadFiles(chosenFiles, number);
  };

  const handleUploadFiles = (files: any, number: number) => {

    if (number === 1) {
      const uploaded = [...uploadedFiles1];

      if(uploadedFiles1.length > 0){

        toast.error(oneFileMessage, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
        })
  
        return;
      }

      let limitExceeded = false;
      files.some((file: any) => {
        if (uploaded.findIndex((f: any) => f.name === file.name) === -1) {
          if (file.size > uploadLimit){
            toast.error(sizeLimitMessage, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
            })
          }
          else{
          uploaded.push(file);
          }
        }
      });
      if (!limitExceeded) setUploadedFiles1(uploaded);
      return;
    }
    if (number === 2) {
      const uploaded2 = [...uploadedFiles2];

      if(uploadedFiles2.length > 0){

        toast.error(oneFileMessage, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
        })
  
        return;
      }

      let limitExceeded = false;
      files.some((file: any) => {
        if (uploaded2.findIndex((f: any) => f.name === file.name) === -1) {

          if (file.size > uploadLimit){
            toast.error(sizeLimitMessage, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
            })
          }
          else{
          uploaded2.push(file);
          }
        }
      });
      if (!limitExceeded) setUploadedFiles2(uploaded2);
      return;
    }
    if (number === 3) {
      const uploaded3 = [...uploadedFiles3];

      if(uploadedFiles3.length > 0){

        toast.error(oneFileMessage, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
        })
  
        return;
      }

      let limitExceeded = false;
      files.some((file: any) => {
        if (uploaded3.findIndex((f: any) => f.name === file.name) === -1) {
          
          if (file.size > uploadLimit){
            toast.error(sizeLimitMessage, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
            })
          }
          else{
          uploaded3.push(file);
          }
        }
      });
      if (!limitExceeded) setUploadedFiles3(uploaded3);
      return;
    }
    if (number === 4) {
      const uploaded4 = [...uploadedFiles4];

      if(uploadedFiles4.length > 0){

        toast.error(oneFileMessage, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
        })
  
        return;
      }

      let limitExceeded = false;
      files.some((file: any) => {
        if (uploaded4.findIndex((f: any) => f.name === file.name) === -1) {

          if (file.size > uploadLimit){
            toast.error(sizeLimitMessage, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
            })
          }
          else{
          uploaded4.push(file);
          }

        }
      });
      if (!limitExceeded) setUploadedFiles4(uploaded4);
      return;
    }
    if (number === 5) {
      const uploaded5 = [...uploadedFiles5];

      if(uploadedFiles5.length > 0){

        toast.error(oneFileMessage, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
        })
  
        return;
      }

      let limitExceeded = false;
      files.some((file: any) => {
        if (uploaded5.findIndex((f: any) => f.name === file.name) === -1) {
          
          if (file.size > uploadLimit){
            toast.error(sizeLimitMessage, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
            })
          }
          else{
          uploaded5.push(file);
          }
        }
      });
      if (!limitExceeded) setUploadedFiles5(uploaded5);
    }
  };


  const validate = () => {
    var validator = new Validator;
    var fields = [
      ['email', email, 'required|email'],
      ['name', name, 'required'],
      ['surname', surname, 'required'],
      ['phone', phone, 'required'],
      ['role', role, 'required'],
    ];
    var errors = validator.run(fields);
    return errors;
  }


  const save = async () => {
    var postData = await getPostData();
    var formErrors = validate();

    var checkUploadedFiles  = uploadedFiles1.length == 0 && uploadedFiles2.length == 0 && uploadedFiles3.length == 0 && uploadedFiles4.length == 0 && uploadedFiles5.length == 0;

    if(checkUploadedFiles){

        toast.error("Başvuru için mutlaka evrak yüklenmelidir", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
        })
        return;
      
    }
  
    if (formErrors.length === 0 && checked) {

      setIsLoading(true);
 
      await axios.post(`${process.env.REACT_APP_API_URL}/User/AddUserForm`, postData, {
        headers: { 'Content-Type': 'application/json' }
      }).then((response) => {
           
        setIsLoading(false);
      

        if (response.data.success) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored"
          })

          setEmail("");
          setName("");
          setSurname("");
          setPhone("");
          setChecked(false);
          setRole("Seçiniz");

          setUploadedFiles1([]);
          setUploadedFiles2([]);
          setUploadedFiles3([]);
          setUploadedFiles4([]);
          setUploadedFiles5([]);

        } else {
          
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored"
          })
        }
      }).catch(err => {
        setIsLoading(false);
  
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored"
       });
  
      
      });
    }
    else {
      toast.error("Lütfen girdiğiniz bilgileri ve zorunlu alanları kontrol ediniz.", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored"
      })
    }
  }


  const validateName = (e: any) => {
    if(e.target.value.match("^[a-zA-Z ğüşöçıİĞÜŞÖÇ]*$")!=null) {
      setName(e.target.value);
    }
  }

  const validateSurname = (e: any) => {
    if(e.target.value.match("^[a-zA-Z ğüşöçıİĞÜŞÖÇ]*$")!=null) {
      setSurname(e.target.value);
    }
  }

  const validatePhone = (e: any) => {
    if(e.target.value.match("^[0-9]{0,10}$")!=null) {
      setPhone(e.target.value);
    }
  }





  return (
    
    <div className={styles.registerPage}>
      <ToastContainer/>
      <div className={styles.content}>
        <div className={styles.left}></div>
        <div className={styles.right}>
          <div className={styles.body}>
            <div className={styles.logo}>
              <img
                src={
                  process.env.REACT_APP_LOCATION === "toroslar"
                    ? ToroslarLogo
                    : process.env.REACT_APP_LOCATION === "baskent"
                    ? BaskentLogo
                    : process.env.REACT_APP_LOCATION === "ayedas"
                    ? AyedasLogo
                    : ""
                }
                alt="icon"
              />
            </div>
           
            <div className={styles.inputArea}>
              <div className={styles.input}>
                <Input
                  type="text"
                  label="Ad"
                  placeholder="Ad"
                  value={name}
                  onChange={(e: any) => 
                    validateName(e)
                  }
                  labelClassName = {styles.required}
                />
              </div>
              <div className={styles.input}>
                <Input
                  type="text"
                  label="Soyad"
                  placeholder="Soyad"
                  value={surname}
                  onChange={(e: any) =>
                    validateSurname(e)
                  }
                  labelClassName = {styles.required}
                />
              </div>
              <div className={styles.input}>
                <Input
                  type="mail"
                  label="Email Adresiniz"
                  placeholder="mail@abc.com"
                  value={email}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setEmail(e.target.value)
                  }
                  labelClassName = {styles.required}
                />
              </div>
              <div className={styles.input}>
                <Input
                  type="phone"
                  label="Telefon Numarası"
                  placeholder="5XXXXXXXXX"
                  value={phone}
                  onChange={(e: any) =>
                    validatePhone(e)
                  }
                  labelClassName = {styles.required}
                />
              </div>
              <SelectComponent
                label="Rol"
                data={data2}
                isArrow={arrow2}
                setIsArrow={setArrow2}
                value={role}
                setValue={(role: string) => setRole(role)}
                placeholder=" Seçiniz"
                labelClassName= {styles.required}
              />
            </div>

            <div className={styles.fileInputArea}>
              <div className={styles.fileInput}>
                <div className={styles.file}>Gerekli Evrak 1</div>
                <div className={styles.fileCenter}>
                  <div className={styles.lowerText}>
                    Eklemek İstediğiniz Dosyayı Seçiniz
                  </div>
                  <label className={styles.fileLabel} htmlFor="file1">
                    <input
                      style={{ display: "none" }}
                      id="file1"
                      type="file"
                      onChange={(e: any) => {
                        handleFileEvent(e, 1);
                      }}
                      accept="image/jpeg,image/png,application/pdf"
                    />
                    Dosya Seç
                  </label>
                </div>
                {uploadedFiles1.length > 0 && (
                  <>
                    <h4>Yüklenen Dosya</h4>
                    {uploadedFiles1.map((item, idx) => (
                      <div className={styles.uploadedFileName} key={idx}>
                        {item.name}
                        <span>
                          <a onClick={(e: any) => {handleFileDeleteEvent(1)}}>  Dosyayı Sil</a>
                        </span>
                      </div>
                      
                    ))}
                  </>
                )}
              </div>
              <div className={styles.fileInput}>
                <div className={styles.file}>Gerekli Evrak 2</div>
                <div className={styles.fileCenter}>
                  <div className={styles.lowerText}>
                    Eklemek İstediğiniz Dosyayı Seçiniz
                  </div>
                  <label className={styles.fileLabel} htmlFor="file2">
                    <input
                      style={{ display: "none" }}
                      id="file2"
                      type="file"
                      onChange={(e: any) => {
                        handleFileEvent(e, 2);
                      }}
                      accept="image/jpeg,image/gif,image/png,application/pdf"
                    />
                    Dosya Seç
                  </label>
                </div>
                {uploadedFiles2.length > 0 && (
                  <>
                    <h4>Yüklenen Dosya</h4>
                    {uploadedFiles2.map((item, idx) => (
                      <div className={styles.uploadedFileName} key={idx}>
                        {item.name}

                        <span>
                          <a onClick={(e: any) => {handleFileDeleteEvent(2)}}>  Dosyayı Sil</a>
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div className={styles.fileInput}>
                <div className={styles.file}>Gerekli Evrak 3</div>
                <div className={styles.fileCenter}>
                  <div className={styles.lowerText}>
                    Eklemek İstediğiniz Dosyayı Seçiniz
                  </div>
                  <label className={styles.fileLabel} htmlFor="file3">
                    <input
                      style={{ display: "none" }}
                      id="file3"
                      type="file"
                      onChange={(e: any) => {
                        handleFileEvent(e, 3);
                      }}
                      accept="image/jpeg,image/gif,image/png,application/pdf"
                    />
                    Dosya Seç
                  </label>
                </div>
                {uploadedFiles3.length > 0 && (
                  <>
                    <h4>Yüklenen Dosya</h4>
                    {uploadedFiles3.map((item, idx) => (
                      <div className={styles.uploadedFileName} key={idx}>
                        {item.name}

                        <span>
                          <a onClick={(e: any) => {handleFileDeleteEvent(3)}}>  Dosyayı Sil</a>
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div className={styles.fileInput}>
                <div className={styles.file}>Gerekli Evrak 4</div>
                <div className={styles.fileCenter}>
                  <div className={styles.lowerText}>
                    Eklemek İstediğiniz Dosyayı Seçiniz
                  </div>
                  <label className={styles.fileLabel} htmlFor="file4">
                    <input
                      style={{ display: "none" }}
                      id="file4"
                      type="file"
                      onChange={(e: any) => {
                        handleFileEvent(e, 4);
                      }}
                      accept="image/jpeg,image/gif,image/png,application/pdf"
                    />
                    Dosya Seç
                  </label>
                </div>
                {uploadedFiles4.length > 0 && (
                  <>
                    <h4>Yüklenen Dosya</h4>
                    {uploadedFiles4.map((item, idx) => (
                      <div className={styles.uploadedFileName} key={idx}>
                        {item.name}

                        <span>
                          <a onClick={(e: any) => {handleFileDeleteEvent(4)}}>  Dosyayı Sil</a>
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div className={styles.fileInput}>
                <div className={styles.file}>Gerekli Evrak 5</div>
                <div className={styles.fileCenter}>
                  <div className={styles.lowerText}>
                    Eklemek İstediğiniz Dosyayı Seçiniz
                  </div>
                  <label className={styles.fileLabel} htmlFor="file5">
                    <input
                      style={{ display: "none" }}
                      id="file5"
                      type="file"
                      onChange={(e: any) => {
                        handleFileEvent(e, 5);
                      }}
                      accept="image/jpeg,image/gif,image/png,application/pdf"
                    />
                    Dosya Seç
                  </label>
                </div>
                {uploadedFiles5.length > 0 && (
                  <>
                    <h4>Yüklenen Dosya</h4>
                    {uploadedFiles5.map((item, idx) => (
                      <div className={styles.uploadedFileName} key={idx}>
                        {item.name}

                        <span>
                          <a onClick={(e: any) => {handleFileDeleteEvent(5)}}>  Dosyayı Sil</a>
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
            <div className={styles.checkboxArea}>
              <Checkbox
                checked={checked}
                setCheckBox={setChecked}
                hrefTarget = "_blank"
                hrefLink = { "./" + process.env.REACT_APP_LOCATION?.toLocaleUpperCase() + "_OSOS_WEB_PORTAL_AYDINLATMA_METNI.pdf"}        
                hrefText= "Online İşlem Merkezi Aydınlatma Metnini"
                label=" okudum, anladım."
                text = ""
                onClick={() => {}}
              />
            </div>
            <div className={styles.button}>
              <Button
                btnType="primary"
                onClick={() => save()}
                text="Kayıt Ol"
                width="420px"
              />
            </div>
            {isLoading ? <LoaderSpinner /> : ""}
          </div>
        </div>
      </div>
    </div>
 
  );
};

export default RegisterPage;